import React from "react";
import { Sparkles } from "lucide-react";
import { useLang } from "@/contexts/LangContext";

export default function Ticker() {
  const { t } = useLang();
  const words = [...t.ticker, ...t.ticker];
  return (
    <div
      data-testid="ticker-strip"
      className="relative overflow-hidden border-y border-white/8 bg-[#0a111f] py-4 select-none"
    >
      <div className="ticker-track flex items-center gap-8 w-max">
        {words.map((w, i) => (
          <span key={`${w}-${i}`} className="flex items-center gap-8">
            <span className="font-display text-sm lg:text-base font-bold uppercase tracking-[0.18em] text-white/55 whitespace-nowrap">
              {w}
            </span>
            <Sparkles className={`h-3.5 w-3.5 shrink-0 ${i % 2 ? "text-brand-orange/70" : "text-brand-blue/70"}`} />
          </span>
        ))}
      </div>
      <style>{`
        .ticker-track { animation: ticker-scroll 30s linear infinite; }
        .ticker-track:hover { animation-play-state: paused; }
        @keyframes ticker-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
      `}</style>
    </div>
  );
}
